// extracted by css-extract-rspack-plugin
export default {"sidebar":"BNm_0","header":"gQEOD","scrollArea":"cJ_K8"};